import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';

import { IQueryStorageItem } from 'app/query-builder/core/query-storage.service';
import { selectCurrentUser } from 'app/_state/auth/auth-selectors';
import { AuthState } from 'app/_state/auth/auth-state';
import { selectCurrentCampaign } from 'app/_state/campaign-context/campaign-context-selectors';
import { CampaignContextState } from 'app/_state/campaign-context/campaign-context-state';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { UserRole, } from 'generated/graphql';
import { filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportComponent extends WithDisposableSubject() implements OnInit {
  /**
   * Radio button value for which UI to display
   */
  exportTypeUi: 'standard' | 'specialized' = 'standard';
  @Input() query: IQueryStorageItem;
  @Input() recordCount: number;
  allowSpecializedExports = true;
  @Output() exportSuccess = new EventEmitter<boolean>();

  constructor(
    private _cd: ChangeDetectorRef,
    private _store: Store<AuthState & CampaignContextState>
  ) {
    super();
  }

  ngOnInit() {

    this._store.select(
      createSelector(
        selectCurrentUser,
        selectCurrentCampaign,
        (user, campaign) => ({ user, campaign }))
    ).pipe(
      takeUntil(this.disposer),
      filter(({ user, campaign }) => !!user && !!campaign)
    )
      .subscribe(({ user, campaign }) => {
        this.allowSpecializedExports =
          UserRole.Organizer === user?.role
            && campaign.restrictedExportingSettings.specializedExportsDisabled
            ? false : true;
        this._cd.markForCheck();
      });
  }
}
